import React, { useState } from "react";
import ItemDetails from "./ItemDetails";
import { Button } from "../../../../../stories/Button/Button";
import { Title } from "../../../../../stories/Title/Title";
import Close from "../../../../../images/Close.svg";
import LeftArrow from "../../../../../images/ArrowRight.svg";
import useAssetTableJson from "../../../../../json/useAssetTableJson";
import { StockEntryTable } from "../stockentry/Add/Add";
import CheckAll from "../../../../../images/MoreInfo.svg";
import Filter from "../../../../../images/Filter.svg";
import DownArrow from "../../../../../images/DownArrow.svg";
import {
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Label } from "../../../../../stories/Label/Label";
import Input from "../../../../../stories/Input/Input";

import { CustomModal } from "../../../../../utils/UtilFunctions";
import { TableHeaderProps } from "../../../../../utils/types";
import ViewConfiguration from "../stockentry/ViewConfiguration";
import { ViewConfigurationStyles } from "../../../../../styles/CustomModalStyles";
import Calendar from "../../../../../images/Calendar.svg";
import CalendarBlack from "../../../../../images/CalendarBlack.svg";
interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}
const ViewStocks = ({ setModalFlag }: Props) => {
  const { Purchase } = useAssetTableJson();

  const [filterColumns, setFilterColumns] = useState(false);
  const [viewConfig, setViewConfig] = useState(false);
  const [columns, setColumns] = useState(Purchase.StockEntry.Add.SubHeader);
  const handleColumnToggle = (field: string) => {
    setColumns((prevColumns) =>
      prevColumns.map((col) => {
        if (
          field === StockEntryTable.Warranty &&
          (col.field === StockEntryTable.Warranty_Start_Date ||
            col.field === StockEntryTable.Warranty_End_Date)
        ) {
          return { ...col, hideable: !col.hideable };
        } else if (
          field === StockEntryTable.Insurance &&
          (col.field === StockEntryTable.INC_Start_Date ||
            col.field === StockEntryTable.INC_end_Date)
        ) {
          return { ...col, hideable: !col.hideable };
        } else if (
          field === StockEntryTable.AMC &&
          (col.field === StockEntryTable.AMC_Start_Date ||
            col.field === StockEntryTable.AMC_End_Date)
        ) {
          return { ...col, hideable: !col.hideable };
        }

        return col.field === field ? { ...col, hideable: !col.hideable } : col;
      })
    );
  };
  const visibleColumns = columns.filter((col) => !col.hideable);

  return (
    <div className="location-stock-view">
      <div className="location-stock-view__title">
        <Title>Stock Details</Title>
        <img src={Close} alt="" onClick={() => setModalFlag(false)} />
      </div>
      <ItemDetails />
      <div className="location-stock-view__header">
        <button className="location-stock-view__header--back">
          <img src={LeftArrow} alt="" />
          Back
        </button>
        <b>Hennur Cross</b>
        <span>Stocks</span>
      </div>
      <div className="location-stock-view__filters row g-0">
        <div className="col"></div>
        <div className="col-4 flex-end">
          <Button onClick={() => setViewConfig(!viewConfig)}>
            <img src={CheckAll} alt="" />
            Check All configurations
          </Button>
          <label
            className="add-stock-entry__block--filter"
            onClick={() => setFilterColumns(!filterColumns)}
          >
            <img src={Filter} alt="" /> Filter Column
            <img src={DownArrow} alt="" />
          </label>
          {filterColumns && (
            <div className="add-stock-entry__block--filter-checkboxes">
              {columns
                .filter(
                  (th) =>
                    ![
                      StockEntryTable.Warranty_Start_Date,
                      StockEntryTable.Warranty_End_Date,
                      StockEntryTable.AMC_Start_Date,
                      StockEntryTable.AMC_End_Date,
                      StockEntryTable.INC_Start_Date,
                      StockEntryTable.INC_end_Date,
                    ].includes(th.field as StockEntryTable)
                )
                .map((col) => (
                  <div key={col.field}>
                    <Checkbox
                      checked={col.hideable ? false : true}
                      onChange={() => {
                        handleColumnToggle(col.field);
                      }}
                    />
                    <Label>{col.headerName}</Label>
                  </div>
                ))}
              <Button
                mode="cancel"
                onClick={() => setFilterColumns(!filterColumns)}
              />
            </div>
          )}
        </div>{" "}
      </div>
      <div className="location-stock-view__select row g-0">
        <div className="col-2">
          <Input id="data_search" placeholder="Search..." />
        </div>
      </div>
      <div className="location-stock-view__tableblock">
        <TableContainer className="stock-balance-add__table">
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {visibleColumns
                  .filter((th) =>
                    [
                      StockEntryTable.SL_No,
                      StockEntryTable.Serial_No,
                      StockEntryTable.Batch,
                      StockEntryTable.Expiry,
                      StockEntryTable.Maintained_By,
                      StockEntryTable.AMC_Enabled,
                      StockEntryTable.Geo_Location,
                      StockEntryTable.Stock_Location,
                      StockEntryTable.Warranty,
                      StockEntryTable.AMC,
                      StockEntryTable.Insurance,
                    ].includes(th.field as StockEntryTable)
                  )
                  .map((th: TableHeaderProps, index: React.Key) => {
                    return (
                      <TableCell
                        key={index}
                        rowSpan={
                          [
                            StockEntryTable.SL_No,
                            StockEntryTable.Serial_No,
                            StockEntryTable.Batch,
                            StockEntryTable.Expiry,
                            StockEntryTable.Maintained_By,
                            StockEntryTable.AMC_Enabled,
                            StockEntryTable.Geo_Location,

                            StockEntryTable.Stock_Location,
                          ].includes(th.field as StockEntryTable)
                            ? 2
                            : 1
                        }
                        colSpan={
                          [
                            StockEntryTable.Warranty,
                            StockEntryTable.AMC,
                            StockEntryTable.Insurance,
                          ].includes(th.field as StockEntryTable)
                            ? 2
                            : 1
                        }
                      >
                        {th.headerName}
                      </TableCell>
                    );
                  })}
              </TableRow>
              <TableRow>
                {visibleColumns
                  .filter((th) =>
                    [
                      StockEntryTable.Warranty_Start_Date,
                      StockEntryTable.Warranty_End_Date,
                      StockEntryTable.AMC_Start_Date,
                      StockEntryTable.AMC_End_Date,
                      StockEntryTable.INC_Start_Date,
                      StockEntryTable.INC_end_Date,
                    ].includes(th.field as StockEntryTable)
                  )
                  .map((th: TableHeaderProps, index: React.Key) => {
                    return (
                      <>
                        <TableCell key={index}>{th.headerName}</TableCell>
                      </>
                    );
                  })}
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                {visibleColumns.map((th: TableHeaderProps, index) => {
                  if (th.field === StockEntryTable.SL_No) {
                    return <TableCell id="td-center">{index + 1}</TableCell>;
                  } else if (th.field === StockEntryTable.Serial_No) {
                    return <TableCell>1 </TableCell>;
                  } else if (th.field === StockEntryTable.Batch) {
                    return <TableCell>batch </TableCell>;
                  } else if (th.field === StockEntryTable.Expiry) {
                    return (
                      <TableCell>
                        11-12-2024 <img src={Calendar} alt="" />{" "}
                      </TableCell>
                    );
                  } else if (th.field === StockEntryTable.Warranty_Start_Date) {
                    return (
                      <TableCell>
                        11-12-2024 <img src={CalendarBlack} alt="" />
                      </TableCell>
                    );
                  } else if (th.field === StockEntryTable.Warranty_End_Date) {
                    return (
                      <TableCell>
                        11-12-2024 <img src={Calendar} alt="" />
                      </TableCell>
                    );
                  } else if (th.field === StockEntryTable.Maintained_By) {
                    return <TableCell></TableCell>;
                  } else if (th.field === StockEntryTable.AMC_Enabled) {
                    return <TableCell></TableCell>;
                  } else if (th.field === StockEntryTable.AMC_Start_Date) {
                    return (
                      <TableCell>
                        11-12-2024 <img src={CalendarBlack} alt="" />
                      </TableCell>
                    );
                  } else if (th.field === StockEntryTable.AMC_End_Date) {
                    return (
                      <TableCell>
                        11-12-2024 <img src={Calendar} alt="" />
                      </TableCell>
                    );
                  } else if (th.field === StockEntryTable.Geo_Location) {
                    return <TableCell></TableCell>;
                  } else if (th.field === StockEntryTable.INC_Start_Date) {
                    return (
                      <TableCell>
                        11-12-2024 <img src={CalendarBlack} alt="" />
                      </TableCell>
                    );
                  } else if (th.field === StockEntryTable.INC_end_Date) {
                    return (
                      <TableCell>
                        11-12-2024 <img src={Calendar} alt="" />
                      </TableCell>
                    );
                  } else if (th.field === StockEntryTable.Stock_Location) {
                    return <TableCell>Hennur</TableCell>;
                  } else return null;
                })}
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <Button mode="cancel" onClick={() => setModalFlag(false)} />
      <CustomModal
        isOpen={viewConfig}
        onRequestClose={() => setViewConfig(!viewConfig)}
        contentComponent={<ViewConfiguration setModalFlag={setViewConfig} />}
        style={ViewConfigurationStyles}
      />
    </div>
  );
};

export default ViewStocks;
